(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/distribution.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/distribution.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const PinIcon = svs.lyckoplatsen.shared_utils.react.components.PinIcon;
const _jotai = jotai,
  useAtom = _jotai.useAtom,
  useAtomValue = _jotai.useAtomValue;
const selectedHighlightedWinGroupAtom = svs.lyckoplatsen.components.shared_result.jotai.atoms.selectedHighlightedWinGroupAtom;
const wagersAtom = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms.wagersAtom;
const formatCurrency = svs.utils.format.Currency;
const wagerHelper = svs.lyckoplatsen.shared_mybets_wager.utils.wagerHelper;
const _React = React,
  useEffect = _React.useEffect;
const Distribution = _ref => {
  let result = _ref.result;
  const wagers = useAtomValue(wagersAtom);
  const distribution = (result === null || result === void 0 ? void 0 : result.distribution) || [];
  const totalAmount = distribution.reduce((acc, dist) => acc + dist.winners * parseInt(dist.amountSek, 10), 0);
  const totalWinners = distribution.reduce((acc, result) => acc + result.winners, 0);
  const _useAtom = useAtom(selectedHighlightedWinGroupAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    highlightedWinGroup = _useAtom2[0],
    setHighlightedWinGroup = _useAtom2[1];
  const wins = wagerHelper.getWins(wagers, result);
  const winDivWins = wins.map(w => w.winDiv);
  const handleRowClick = index => {
    if (highlightedWinGroup === index) {
      setHighlightedWinGroup(null);
    } else {
      setHighlightedWinGroup(index);
    }
  };
  useEffect(() => setHighlightedWinGroup(null), [setHighlightedWinGroup, result]);
  return React.createElement("div", {
    className: "lp-distribution f-content"
  }, React.createElement("div", {
    className: "distribution-body"
  }, React.createElement("div", {
    className: "distribution-table ".concat(highlightedWinGroup || highlightedWinGroup === 0 ? 'has-selected' : '')
  }, React.createElement("div", {
    className: "table-row row-headers"
  }, React.createElement("div", {
    className: "row-winners"
  }, "Vinnare"), React.createElement("div", {
    className: "row-distance"
  }, "Distans"), React.createElement("div", {
    className: "row-amount"
  }, "Vinst")), distribution.map((item, index) => {
    const classNames = ['table-row'];
    highlightedWinGroup === index && classNames.push('selected');
    winDivWins.includes(index) && classNames.push('win');
    const winners = index === 0 && winDivWins.includes(index) ? 'Du' : "".concat(formatCurrency(item.winners), " st");
    return React.createElement("div", {
      className: classNames.join(' '),
      key: index,
      onClick: () => handleRowClick(index),
      onKeyDown: e => {
        if (e.key === 'Enter') {
          handleRowClick(index);
        }
      },
      tabIndex: 0
    }, React.createElement("div", {
      className: "row-winners"
    }, React.createElement("span", null, winners)), React.createElement("div", {
      className: "row-distance padding-h-1"
    }, index !== 0 && React.createElement("span", null, "< ".concat(svs.lyckoplatsen.utils.format.formatDistance(item.distanceMeters))), index === 0 && React.createElement(PinIcon, {
      color: "white"
    })), React.createElement("div", {
      className: "row-amount"
    }, "".concat(formatCurrency(item.amountSek), " kr"), " "));
  }), React.createElement("div", {
    className: "table-footer"
  }, "Totalt vinstbelopp: ", "".concat(formatCurrency(totalAmount), " kr"), " ", React.createElement("br", null), "Antal vinnare: ", "".concat(formatCurrency(totalWinners), " st")))));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  Distribution
});

 })(window);